import { hashHistory } from 'react-router';

// All paths
const PATHS = {
  BOOK: 'book',
};

// Exported paths
export const MAIN_PATH = PATHS.BOOK;

// List
export const bookCarparksListPath = () => `${MAIN_PATH}`;
export const navigateToBookCarparksList = () => {
  hashHistory.push(bookCarparksListPath());
};

// Book
export const bookPath = (carparkId) => `${MAIN_PATH}/${carparkId}`;
export const navigateToBook = (carparkId, query = {}) => {
  hashHistory.push({
    pathname: bookPath(carparkId),
    query,
  });
};



// WEBPACK FOOTER //
// ./routes/book/navigation.js